<template>
  <v-dialog v-model="dialog" @keydown.esc="cancel" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">要配慮者施設状況の詳細</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="6">
              <v-text-field
                v-model="item.fa_name"
                label="施設名"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="6">
              <v-text-field
                v-model="item.fa_name_kana"
                label="施設名（カナ）"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                label="避難状況"
                :value="$facility.evacuationStatusName(item)"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col class="caption search-item-caption">
              避難対象者数
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                v-model="item.evacuee_vala"
                label="教員/職員"
                suffix="人"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                v-model="item.evacuee_valb"
                label="患者/児童/生徒/入所者"
                suffix="人"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.fa_address"
                label="施設住所"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="item.free_input"
                label="備考"
                v-bind="formControlProps"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                label="施設種別"
                :value="$facility.facilityTypeName(item)"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                label="シェルター有無"
                :value="$facility.shelterExistName(item)"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                label="管理区域"
                :value="$facility.controlledAreaName(item)"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                v-model="item.max_capacity"
                label="最大収容人数"
                suffix="人"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="6">
              <v-text-field
                v-model="item.municip_name"
                label="市町村"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="6">
              <v-text-field
                v-model="item.area_name"
                label="地域（地区）"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="6">
              <v-text-field
                v-model="item.fa_respons_person"
                label="施設管理者/責任者"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                v-model="item.fa_phone"
                label="連絡先電話番号"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10">
              <v-text-field
                v-model="item.fa_mail_address"
                label="連絡先メールアドレス"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="6">
              <v-text-field
                v-model="item.latitude"
                label="緯度"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="6">
              <v-text-field
                v-model="item.longitude"
                label="経度"
                v-bind="formControlProps"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" color="primary" @click.native="cancel">
          戻る
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from "vue";
import config from "@/js/const";
import Facility from "@/plugins/facility";
Vue.use(Facility);
export default {
  data: () => ({
    config: config,
    dialog: false,
    resolve: null,
    reject: null,
    item: []
  }),
  computed: {
    formControlProps() {
      return {
        placeholder: config.PLACEHOLDER_SP,
        disabled: true
      };
    }
  },
  methods: {
    open(item) {
      this.dialog = true;
      this.item = item;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
